/**
 * Shared Tailwind classes for labels and native controls (input/textarea/select)
 * so auth flows, modals, and master forms stay visually consistent.
 */
export const formLabelClass =
  'block text-sm font-semibold text-slate-700 mb-1 tracking-tight';

/**
 * @param {object} [opts]
 * @param {boolean} [opts.error]
 * @param {string} [opts.className]
 */
export function formControlClass(opts = {}) {
  const { error = false, className = '' } = opts;
  const base = [
    'w-full rounded-lg border px-3.5 py-2.5',
    'bg-white text-slate-900 placeholder:text-slate-400',
    'shadow-sm transition-[box-shadow,border-color,background-color] duration-200',
    'focus:outline-none focus:ring-2 focus:border-primary-300',
    error
      ? 'border-rose-300 bg-rose-50/90 focus:ring-rose-400/25 focus:border-rose-400'
      : 'border-slate-200 hover:border-slate-300 focus:ring-primary-500/20',
    'disabled:cursor-not-allowed disabled:opacity-55 disabled:bg-slate-50',
  ].join(' ');
  return `${base} ${className}`.trim();
}
